// extracted by mini-css-extract-plugin
export default {"PageCounter":"PageCounter_PageCounter__dKViM"};